import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Target } from 'lucide-react';
import { api } from '../utils/api';

/**
 * ONBOARD-01 — Upgrade prompt modal.
 * Shown to Starter users once, the first time `consultations_used >= 12`
 * AND `user.onboarding.upgrade_prompt_12_shown === false`.
 *
 * Dismissal is recorded via PATCH /api/auth/onboarding-prompt-shown so the
 * modal NEVER reappears, regardless of which CTA the user clicks.
 */
export const UpgradePromptModal = ({ open, onOpenChange, onAcknowledged }) => {
  const navigate = useNavigate();

  const recordAndClose = async (gotoBilling = false) => {
    try { await api.markUpgradePromptShown(); } catch { /* best-effort */ }
    onAcknowledged?.();
    onOpenChange(false);
    if (gotoBilling) navigate('/upgrade?source=upgrade_modal');
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) recordAndClose(false); }}>
      <DialogContent className="max-w-md" data-testid="upgrade-prompt-modal">
        <DialogHeader>
          <div
            className="w-12 h-12 rounded-full mx-auto mb-2 flex items-center justify-center"
            style={{ backgroundColor: 'rgba(168, 85, 247, 0.12)' }}
          >
            <Target className="w-6 h-6" style={{ color: '#a855f7' }} />
          </div>
          <DialogTitle className="text-center text-xl" data-testid="upgrade-prompt-title">
            Você está aproveitando bem o Akali AI! 🎯
          </DialogTitle>
          <DialogDescription className="text-center text-sm">
            Você já gerou 12 documentações. Com o plano Solo, você tem 80 consultas/mês,
            exportação PDF com logo e suporte prioritário.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-col gap-2 sm:gap-2">
          <Button
            className="w-full bg-primary hover:bg-primary-hover"
            onClick={() => recordAndClose(true)}
            data-testid="upgrade-prompt-go-billing"
          >
            Ver plano Solo — R$ 129/mês
          </Button>
          <Button
            variant="ghost"
            className="w-full"
            onClick={() => recordAndClose(false)}
            data-testid="upgrade-prompt-dismiss"
          >
            Continuar grátis
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradePromptModal;
